import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum UserMaintenanceOrderItem {
  /** ユーザID */
  userId = '1',
  /** 予備名称1 */
  mstSpareNameOne = '2',
  /** 予備名称2 */
  mstSpareNameTwo = '3',
}

const nameConfig = {
  userId: new Map([
    [Locale.ja, 'ユーザID'],
    [Locale.en, 'User Id'],
  ]),

  mstSpareNameOne: new Map([
    [Locale.ja, '予備名称1'],
    [Locale.en, 'Master Spare Name One'],
  ]),

  mstSpareNameTwo: new Map([
    [Locale.ja, '予備名称2'],
    [Locale.en, 'Master Spare Name Two'],
  ]),
};

const toEnum = rawValueToEnum(UserMaintenanceOrderItem, UserMaintenanceOrderItem.userId);
const toDisplay = enumToName(UserMaintenanceOrderItem, nameConfig);
const toDisplayWithPrefix = enumToName(UserMaintenanceOrderItem, nameConfig, { prefix: true });

export const userMaintenanceOrderItem = {
  enum: UserMaintenanceOrderItem,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { UserMaintenanceOrderItem };
